/**
 * Bayi panelinde (Hayat/Abant) kapanan (`HANDLED_EXTERNALLY`) bir siparişin SONUCU: teslim mi,
 * iptal mi, yoksa hâlâ panelde işlemde mi ("Araç Listesinde" vb.)?
 *
 * `HANDLED_EXTERNALLY` durumu bunların HEPSİNİ kapsıyordu; rapor, pano ve müşteri özeti
 * iptalleri de ciroya/tamamlanana katıyordu. Ayrım `Order.externalStatusRaw` metninden
 * çıkarılır.
 *
 * İki marka aynı sınıflandırıcıdan geçer:
 *   - Hayat: "Teslim Edildi(Bayi)", "İptal-Müşteri Vazgeçti", "Araç Listesinde"…
 *   - Abant: "Teslim Edildi", "İptal", "Ödeme Başarısız", "Teslim Edilemedi"…
 *
 * Defter DEĞİŞMEZ; bu yalnız sunum katmanı sınıflandırıcısıdır.
 */
export type HayatOutcome = 'delivered' | 'cancelled' | 'pending';

/**
 * Önekler sırayla sınanır: "TESLİM EDİLEMEDİ" iptal kabul edilir ve "TESLİM EDİLDİ" kontrolünden
 * ÖNCE bakılır — aksi hâlde "TESLİM EDİLEMEDİ" yanlışlıkla delivered sayılırdı.
 */
const CANCELLED_NOT_DELIVERED_PREFIX = 'TESLİM EDİLEMEDİ';
const DELIVERED_PREFIX = 'TESLİM EDİLDİ';
const CANCELLED_PAYMENT_PREFIX = 'ÖDEME BAŞARISIZ';
const CANCELLED_PREFIX = 'İPTAL';

function normalize(s: string): string {
  return s.normalize('NFC').toLocaleUpperCase('tr-TR').trim();
}

/**
 * `raw` boş/null ise `null` döner (bayi paneli durumu hiç okunamamış demektir).
 * Aksi halde yukarıdaki öneklere göre "delivered" / "cancelled" / "pending" döner.
 *
 * Geriye dönük uyumluluk: eski ad `hayatOutcome` KALIR; yeni ad `panelOutcome` aynı fonksiyona
 * bağlanır. `panelOutcome` adı tercih edilir — sınıflandırıcı artık yalnız Hayat için değil.
 */
export function hayatOutcome(raw: string | null | undefined): HayatOutcome | null {
  return panelOutcome(raw);
}

export function panelOutcome(raw: string | null | undefined): HayatOutcome | null {
  if (!raw) return null;
  const norm = normalize(raw);
  if (!norm) return null;
  if (norm.startsWith(CANCELLED_NOT_DELIVERED_PREFIX)) return 'cancelled';
  if (norm.startsWith(DELIVERED_PREFIX)) return 'delivered';
  if (norm.startsWith(CANCELLED_PAYMENT_PREFIX)) return 'cancelled';
  if (norm.startsWith(CANCELLED_PREFIX)) return 'cancelled';
  return 'pending';
}
